function DashboardHeader() {
  return (
    <div className="border-b border-gray-200 pt-4">
      <h1 className="text-4xl pl-4">synIntel</h1>
    </div>
  )
}
export default DashboardHeader;